(function($) {

    var defaultOptions = {
        dataAttribute: "image-src",
        imageClass: ""
    };

    $.fn.tryLoadImage = function(options) {
        var settings = $.extend(defaultOptions, options),
            attrFilter = ['[', 'data-', settings.dataAttribute, ']'].join('');

        this.filter(attrFilter).each(function() {
            var eventProps,
                placeholder = $(this),
                url = placeholder.data('image-src'),
                img = $('<img/>'),
                timeouts = [5000, 10000, 15000, 30000];

            if (placeholder.data('tryLoadImage')) {
                return;
            }

            placeholder.data('tryLoadImage', true);

            eventProps = {
                imgElem: img,
                imgUrl: url,
                placeholderElem: placeholder
            };

            function tryLoad() {
                // Triggers load of image
                img.attr('src', url);
            }

            img.on('error', function(originalEvent) {
                var event = $.Event(originalEvent, eventProps);
                event.type = "imageerror";
                placeholder.trigger(event);

                if (timeouts.length > 0) {
                    setTimeout(tryLoad, timeouts.shift());
                } else {
                    placeholder.addClass('broken');
                }
            });

            img.on('load', function(originalEvent) {
                var event = $.Event(originalEvent, eventProps);
                event.type = "imageload";
                img.addClass(settings.imageClass)
                   .insertAfter(placeholder);
                // This could be optimized by copying the events from
                // placeholder to the created img tag
                placeholder.detach()
                           .trigger(event);
            });

            tryLoad();
        });

        return this;
    };

}(jQuery));
